<template>
  <div style="overflow: hidden">
    <div class="bjffff"></div>
    <div class="btBox">
      <div class="cont">
        <div class="logoimg img">
          <img
            src="../../assets/img/logo-p.png"
            @click="jump"
            alt=""
            srcset=""
          />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="leftCont">
        <div class="box on" v-for="item in typeList" @click="typeClick(index)">
          {{ item.name }}
        </div>
      </div>
      <div class="ritCont">
        <div class="name">隐私协议</div>
        <div class="cont" v-html="info.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Form, Input, Button, Upload, Icon } from "ant-design-vue";
import Zhuce from "../component/zhuce.vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-input-password": Input.Password,
    "a-button": Button,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    Zhuce,
  },
  name: "",
  data() {
    return {
      typeOn: 0,
      typeList: [
        {
          id: "1",
          name: "隐私协议",
        },
      ],
      zhShow: false,
      mobile: "",
      password: "",
      time: 60,
      yzmShow: false,
      yanzheng: "",
      info: {},
    };
  },
  created() {
    this.get();
  },
  methods: {
    jump() {
      this.$router.push({
        path: "/index",
      });
    },
    get() {
      this.$get("/common/agreement_get", {
        id: 1,
      }).then((res) => {
        console.log(res);
        this.info = res.data;
      });
    },
    typeClick(i) {
      this.typeOn = i;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.btBox {
  width: 100%;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 99;
  background-color: #fff;
  box-shadow: 0 2px 2px 1px whitesmoke;
  font-family: PingFangSC-Regular, sans-serif;
  .cont {
    width: 1440px;
    margin: auto;
    display: flex;
    height: 55px;
    align-items: center;
    justify-content: space-between;

    .logoimg {
      height: 30px;
      display: flex;
      align-items: center;

      img {
        height: 100%;
        width: auto;
      }

      .shu {
        width: 1px;
        height: 15px;
        margin: 0 10px;
        background-color: #999;
      }

      .name {
        font-size: 18px;
        font-weight: 700;
        color: #333;
      }
    }
  }
}
.content {
  width: 1280px;
  margin: auto;
  margin-top: 10px;
  display: flex;
  .leftCont {
    width: 200px;
    border-right: 1px solid whitesmoke;
    font-size: 18px;
    .box {
      height: 60px;
      line-height: 60px;
      cursor: pointer;
    }
    .on {
      font-weight: 600;
      color: #0d7ee9;
    }
  }
  .ritCont {
    width: calc(100% - 201px);
    box-sizing: border-box;
    padding: 20px 30px;
    .name {
      font-size: 20px;
      font-weight: 600;
    }
  }
}
.zcTxt {
  text-align: right;
  padding-right: 25px;
  color: #888;
  font-size: 12px;
  margin-bottom: 15px;
  cursor: pointer;
}
</style>
